import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import {stripHtml} from '../../../../utils/text';

const MultipleNumber3RowType = ({rows}) => (
    <table className="table table-sm">
        <thead>
            <tr>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.id} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.text} /></th>
            </tr>
        </thead>
        <tbody>
            {rows.map((r) => (
                <tr key={r.id}>
                    <td className="value-id">{r.id}</td>
                    <td>{stripHtml(r.label)}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default MultipleNumber3RowType;
